export const dlProductAllPhotosUploadedEvent = (type, layout) => {
    window.dataLayer.push({
        event: 'Upload All Photos',
        custom: { type, layout }
    });
};
